import * as Address from '../../address';
import * as Previsit from '../../previsit';

import { PatientInsuranceInformation } from '../..';
import { Nullable, Relationship } from '../../common';
import { InsuranceInformationWithDetails } from '../../patient/insuranceInformation';

export enum PolicyHolderOption {
  Patient = 'PATIENT',
  PatientsSpouse = 'PATIENTS_SPOUSE',
  SomeoneElse = 'SOMEONE_ELSE',
}

export enum Footprint {
  AnsweredEditContinue = 'ANSWERED_EDIT_CONTINUE',
  AnsweredInsuranceHasChanged = 'ANSWERED_INSURANCE_HAS_CHANGED',
  AnsweredPayingWithInsurance = 'ANSWERED_PAYING_WITH_INSURANCE',
  AnsweredPayingWithoutInsurance = 'ANSWERED_PAYING_WITHOUT_INSURANCE',
  AnsweredReviewStillValid = 'ANSWERED_REVIEW_STILL_VALID',
  CanceledAddCard = 'CANCELED_ADD_CARD',
  ConfirmedInsurance = 'CONFIRMED_INSURANCE',
  EditingIncompleteInsurance = 'EDITING_INCOMPLETE_INSURANCE',
  FullyUploaded = 'FULLY_UPLOADED',
  InactiveRteResponse = 'INACTIVE_RTE_RESPONSE',
  InsuranceNotFoundWithRte = 'INSURANCE_NOT_FOUND_WITH_RTE',
  OcrSkipped = 'OCR_SKIPPED',
  PayorNotSupportedForRte = 'PAYOR_NOT_SUPPORTED_FOR_RTE',
  PressedBackPhotoIcon = 'PRESSED_BACK_PHOTO_ICON',
  PressedFrontPhotoIcon = 'PRESSED_FRONT_PHOTO_ICON',
  RemovedInsurance = 'REMOVED_INSURANCE',
  ReviewDirectSubmit = 'REVIEW_DIRECT_SUBMIT',
  RteError = 'RTE_ERROR',
  RteTimeout = 'RTE_TIMEOUT',
  SkippedInsurance = 'SKIPPED_INSURANCE',
  SubmittedSubscriberDetails = 'SUBMITTED_SUBSCRIBER_DETAILS',
  UploadedBack = 'UPLOADED_BACK',
  UploadedFront = 'UPLOADED_FRONT',
  VerifiedActiveWithRte = 'VERIFIED_WITH_RTE',
}

export type BaseSubscriber = Nullable<{
  primaryPolicyHolderFirstName: string;
  primaryPolicyHolderMiddleName: string;
  primaryPolicyHolderLastName: string;
  primaryPolicyHolderDob: Date;
  primaryPolicyHolderMemberId: string;
  primaryPolicyHolderSex: Previsit.Sex;
  primaryPolicyHolderAddressId: string;
  primaryPolicyHolderHomePhone: string;
  primaryPolicyHolderWorkPhone: string;
  primaryPolicyHolderEmployer: string;
  primaryPolicyHolderRetirementDate: Date;
  primaryPolicyHolderEmploymentStatus: Previsit.EmploymentStatus;
  primaryPolicyHolderEmploymentStatusRaw: string;
  primaryPolicyHolderRelationshipToGuarantor: Relationship;
  primaryPolicyHolderRelationshipToGuarantorRaw: string;
  patientRelationshipToPrimaryPolicyholder: Relationship;
}>;

export interface PrevisitSubscriber extends BaseSubscriber {
  id: string;
  primaryPolicyHolderAddress: Address.Address | null;
  newlyAdded?: boolean;
}

export interface InsuranceCoverage
  extends PatientInsuranceInformation.InsuranceCardInformation {
  id: string;
  subscriberId: string | null;
}

export interface InsuranceCoverageWithUpdates extends InsuranceCoverage {
  ehrPlanId: string | null;
  planName: string | null;
}

export interface PrevisitInsuranceFormFieldValue {
  skippedInsurance?: boolean;
  extractedPatientInsuranceCoverages?: InsuranceInformationWithDetails[];
  payingWithInsurance?: boolean;
  footprint?: Footprint;
  subscribers: PrevisitSubscriber[];
  insuranceCoverages?: InsuranceCoverage[];
  addedInsuranceIds?: string[];
  confirmedInsuranceIds?: string[];
  invalidInsuranceIds?: string[];
  unverifiedInsuranceIds?: string[];
}
